// Helper to build a canonical URL (origin + pathname only)
// Strips query & hash by ignoring them and normalizes trailing slash (removed for non-root paths)
// We have campaigns that pass in query params, so we need to ensure canonical URLs are clean or "we lose 'link juice'"
export default function getCanonicalUrl() {
  if (typeof window === 'undefined' || !window.location?.origin) return ''
  const { origin, pathname = '/' } = window.location
  const trimmedPath = pathname !== '/' && !pathname.endsWith('/') ? `${pathname}/` : pathname
  return `${origin}${trimmedPath}`
}
